'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";
import apiService from "@/Common/ApiService";
import MutexService from "@/Common/MutexService";


let FieldOptionService = {

    IsQuery: false,
    IsComplexQuery: false,

    fieldsToQuery: [],
    complexFieldsToQuery: [],


    fieldOptionsSet: {},
    complexFieldOptionsSet: {},

    complexFieldOptionValueSet: {},

    ClearAllOptions() {
        this.fieldOptionsSet = {};

        //this.fieldsToQuery = [];
        //this.complexFieldsToQuery = [];

        this.complexFieldOptionsSet = {};
        this.complexFieldOptionValueSet = {};
    },

    GetFieldOptions_Mutex(fieldName, dataLanguage, useCacheOption, callBackHandler) {
        let resolveHandler = null;
        let resultPromise = new Promise((resolve) => {
            resolveHandler = resolve;
        });
        let options = null;
        let key;


        if (useCacheOption == null) {
            useCacheOption = true;
        }


        if (dataLanguage == null) {
            dataLanguage = "ZH_TW";
        }

        key = fieldName + "@" + dataLanguage;

        if ((options = this.fieldOptionsSet[key]) != null) {
            if (callBackHandler != null) {
                callBackHandler(options);
                resolveHandler(options);
            }
        }
        else {
            MutexService.Lock("FieldOptionService").then(
                function (callBack) {

                    if ((options = this.fieldOptionsSet[key]) != null) {
                        if (callBackHandler != null) {
                            callBackHandler(options);
                            resolveHandler(options);
                        }
                    }
                    else {
                        this.fieldsToQuery.push(
                            {
                                FieldName: fieldName,
                                DataLanguage: dataLanguage,
                                CallBackHandler:

                                    function (result) {

                                        if (useCacheOption) {
                                            this.fieldOptionsSet[key] = result;
                                        }

                                        if (callBackHandler != null) {
                                            callBackHandler(result);
                                        }

                                        if (resolveHandler != null) {
                                            resolveHandler(result);
                                        }
                                    }.bind(this)
                            }
                        );


                        if (!this.IsQuery) {
                            this.IsQuery = true;

                            setTimeout(
                                function () {
                                    this.QueryOptionsList();
                                }.bind(this),
                                100
                            );
                        }
                    }

                    callBack("OK");

                }.bind(this)
            );
        }

        MutexService.Lock("FieldOptionService").then(
            (callBack) => {

                if (dataLanguage == null) {
                    dataLanguage = "ZH_TW";
                }


                key = fieldName + "@" + dataLanguage;



                if ((options = this.fieldOptionsSet[key]) != null) {
                    if (callBackHandler != null) {
                        callBackHandler(options);
                    }

                    if (resolveHandler != null) {
                        resolveHandler(options);
                    }

                }
                else {
                    this.fieldsToQuery.push(
                        {
                            FieldName: fieldName,
                            DataLanguage: dataLanguage,
                            CallBackHandler: (result) => {

                                if (callBackHandler != null) {
                                    callBackHandler(result);
                                }


                                if (resolveHandler != null) {
                                    resolveHandler(result);
                                }
                            }
                        }
                    );


                    if (!this.IsQuery) {
                        this.IsQuery = true;

                        setTimeout(
                            function () {
                                this.QueryOptionsList();
                            }.bind(this),
                            100
                        );
                    }
                }

                callBack("OK");
            }
        );


        return resultPromise;


    },



    GetFieldOptions(fieldName, dataLanguage, useCacheOption , callBackHandler) {
        let resolveHandler = null;
        let resultPromise = new Promise((resolve) => {
            resolveHandler = resolve;
        });
        let options = null;
        let key;

 
        if (useCacheOption == null) {
            useCacheOption = true;
        }
         
 

        //console.log("GetFieldOptions fieldName:" + fieldName);

        if (dataLanguage == null) {
            dataLanguage = "ZH_TW";
        }


        key = fieldName + "@" + dataLanguage;



        if (useCacheOption && (options = this.fieldOptionsSet[key]) != null) {
            if (callBackHandler != null) {
                callBackHandler(options);
            }

            if (resolveHandler != null) {
                resolveHandler(options);
            }
        }
        else {
            this.fieldsToQuery.push(
                {
                    FieldName: fieldName,
                    DataLanguage: dataLanguage,
                    CallBackHandler: (result) => {

                        if (callBackHandler != null) {
                            callBackHandler(result);
                        }

                        if (resolveHandler != null) {
                            resolveHandler(result);
                        }
                    }
                }
            );


            if (!this.IsQuery) {
                this.IsQuery = true;

                setTimeout(
                    function () {
                        this.QueryOptionsList();
                    }.bind(this),
                    100
                );
            }
        }


        return resultPromise;


    },

    LastGetComplexFieldOptionsTime: new Date(),


    IsCacheComplexOptionContainAllValue(fieldName, dataLanguage, optionValue) {
        let containAllOptionValue = true;
        let existingOptions, optionValues;
        let key;
        let i;


        if (optionValue != null && optionValue != "") {
             

            key = "Complex@" + fieldName + "@" + dataLanguage;

            existingOptions = this.complexFieldOptionsSet[key];

            optionValues = (optionValue + "").split(",");

            if (optionValues != null && existingOptions != null) {
                let someValueNotContain;

                someValueNotContain = optionValues.some(
                    optValue => !existingOptions.some(extOption => extOption.Value == optValue)
                );

                if (someValueNotContain) {
                    containAllOptionValue = false;
                }
            }

        }//end  if (optionValue != null && optionValue != "") {

        return containAllOptionValue;
    },//end IsCacheComplexOptionContainAllValue(fieldName, dataLanguage, optionValue) {


    GetCacheComplexOptions(fieldName, dataLanguage, optionValue) {
        let key;
        let existingOptions;

        key = "Complex@" + fieldName + "@" + dataLanguage;

        existingOptions = this.complexFieldOptionsSet[key];

        if (existingOptions == null) {
            existingOptions = [];
        }


        return existingOptions;
    },


    GetCacheComplexOptionText(fieldName, dataLanguage, optionValue) {
        let resultText = "";
        let containAllOptionValue = true;
        let optionTexts = [];
        let key;
        let i;


        if (optionValue != null && optionValue != "") {
            let existingOptionValues = [];

            optionValues = (optionValue + "").split(",");

            key = "Complex@" + fieldName + "@" + dataLanguage;

            existingOptions = this.complexFieldOptionsSet[key];

            if (optionValues != null && existingOptions != null) {
                let existingOption;
                let i;

                for (i = 0; i < optionValues.length; i++) {
                    let optValue;

                    optValue = optionValues[i];

                    existingOption = existingOptions.find(extOption => extOption.Value == optValue)

                    if (existingOption != null) {
                        optionTexts.push(existingOption.Text);
                    }
                    else {
                        optionTexts.push(existingOption.Value);
                    }
                }
            }
        }//end  if (optionValue != null && optionValue != "") {

        resultText = optionTexts.join(",");

        return resultText;
    },//end GetCacheComplexOptionText(fieldName, dataLanguage, optionValue) {


    GetComplexFieldOptions(fieldName, dataLanguage, optionValue, useCacheOption, callBackHandler) {
        let resultPromise;
        let options = null;
        let resolveHandler = null;
        let existingOptions;
        let optionValues = null;
        let containAllOptionValue = true;
        let key;


        if (fieldName == "DivisionId" && optionValue == null) {
            console.log("optionValue of ComplexOption DivisionId can not be null ");


            return Promise.resolve(
                [
                    {
                        Value: null,
                        Text: ""
                    }
                ]
            );

        }

        if (useCacheOption == null) {
            useCacheOption = true;
        }

 
        //console.log("GetComplexFieldOptions fieldName:" + fieldName);

        if (dataLanguage == null) {
            dataLanguage = "ZH_TW";
        }

        this.LastGetComplexFieldOptionsTime = new Date();

        key = "Complex@" + fieldName + "@" + dataLanguage;


        if (useCacheOption == null || useCacheOption == true) {
            if (optionValue != null && optionValue != "") {
                let existingOptionValues;

                optionValues = (optionValue + "").split(",");

                existingOptionValues = this.complexFieldOptionValueSet[fieldName];

                if (existingOptionValues == null) {
                    existingOptionValues = [];
                    this.complexFieldOptionValueSet[fieldName] = existingOptionValues;
                }

                optionValues.forEach(
                    function (value) {
                        if (existingOptionValues.indexOf(value) < 0) {
                            existingOptionValues.push(value);
                        }
                    }.bind(this)
                );

                //key += "@" + optionValue;
            }//end  if (optionValue != null && optionValue != "") {
        }//end  if (useCacheOption == null || useCacheOption == true) {


        resultPromise = new Promise(
            (resolve, reject) => {
                resolveHandler = resolve;
            }
        );


        if (useCacheOption == null || useCacheOption == true) {
            existingOptions = this.complexFieldOptionsSet[key];

            if (optionValues != null && existingOptions != null) {
                let someValueNotContain;

                someValueNotContain = optionValues.some(
                    optValue => !existingOptions.some(extOption => extOption.Value == optValue)
                );

                if (someValueNotContain) {
                    containAllOptionValue = false;
                }
            }
        }
        else {
            containAllOptionValue = false;
        }

        if ((options = this.complexFieldOptionsSet[key]) != null && containAllOptionValue) {


            if (callBackHandler != null) {
                callBackHandler(options);
            }

            if (resolveHandler != null) {
                resolveHandler(options);
            }
        }
        else {
            let existed;


            existed = this.complexFieldsToQuery.some(
                (query) => {
                    let match;

                    match =
                        (query.FieldName == fieldName) &&
                        (query.DataLanguage == dataLanguage);

                    return match;
                }
            );


            //console.log("this.complexFieldsToQuery.push : " + fieldName);

            this.complexFieldsToQuery.push(
                {
                    Invoked: false,

                    FieldName: fieldName,
                    DataLanguage: dataLanguage,
                    OptionValue: useCacheOption?null:optionValue , //OptionValue �̫�A�h�ǳ�
                    CallBackHandler: (options) => {

                        

                        if (resolveHandler != null) {
                            resolveHandler(options);
                        }

                        if (callBackHandler != null) {
                            callBackHandler(options);
                        }
                    }
                }
            );

             
            //console.log("this.complexFieldsToQuery.length : " + this.complexFieldsToQuery.length);

        }

        if (!this.IsComplexQuery) {
            this.IsComplexQuery = true;

            setTimeout(
                function () {
                    //debugger;   
                    this.QueryComplexOptionsList();
                    //this.complexFieldsToQuery.length = 0;
                }.bind(this),
                10
            );

            setTimeout(
                function () {
                    let currDate = new Date();

                    if (currDate - this.LastGetComplexFieldOptionsTime > 1000) {
                        this.complexFieldsToQuery.length = 0;
                        this.ComplexFieldsToQueryIndex = 0;
                    }

                }.bind(this),
                2000
            );
        }
        else {
            //console.log("No Need");

        }


        return resultPromise;
    },


    QueryOptionsList() {
        let fieldsToQuerySession = [];
        let i;

        this.IsQuery = true;

        //console.log("FieldOptionService:QueryOptionsList()");

        for (i = 0; i < this.fieldsToQuery.length; i++) {
            fieldsToQuerySession.push(this.fieldsToQuery[i]);
        }


        //console.log("FieldOptionService:QueryOptionsList() , fieldsToQuerySession.length=" + fieldsToQuerySession.length);


        this.fieldsToQuery.length = 0;
        this.IsQuery = false;


        console.log("QueryOptionsList:apiService.Post");
        apiService.Post("/api/FieldOptionMaster/QueryOptionsList", fieldsToQuerySession).then(
            function (fieldOptionsList) {
                let callBackHandler = null;
                let fieldName = "", dataLanguage = "", options = [];
                let i, j;


                for (i = 0; i < fieldOptionsList.length; i++) {

                    fieldName = fieldOptionsList[i].FieldName;
                    options = fieldOptionsList[i].Options;
                    dataLanguage = fieldOptionsList[i].DataLanguage;

                    this.fieldOptionsSet[fieldName + "@" + dataLanguage] = options;

                    callBackHandler = fieldsToQuerySession[i].CallBackHandler;

                    if (callBackHandler != null) {
                        callBackHandler(options);
                    }

                }

                this.IsQuery = false;
            }.bind(this)
        ).catch(
            (error) => {
                alert(error);
            }
        );


    },




    ComplexFieldsToQueryIndex: 0,


    QueryComplexOptionsList() {
        let complexFieldsToQuerySession = [];
        let i;

        this.IsComplexQuery = true;


        //console.log("FieldOptionService:QueryOptionsList()");
        for (i = this.ComplexFieldsToQueryIndex; i < this.complexFieldsToQuery.length; i++) {
            let fieldName, dataLanguage;
            let existed;
            let optionValues;


            fieldName = this.complexFieldsToQuery[i].FieldName;
            dataLanguage = this.complexFieldsToQuery[i].DataLanguage;

            optionValues = this.complexFieldOptionValueSet[fieldName];

            if (optionValues != null && optionValues.length > 0) {
                this.complexFieldsToQuery[i].OptionValue = optionValues.join(",");
            }

            existed = complexFieldsToQuerySession.some(
                querySession =>
                    querySession.FieldName == fieldName &&
                    querySession.DataLanguage == dataLanguage
            );

            if (!existed) {
                complexFieldsToQuerySession.push(this.complexFieldsToQuery[i]);
            }
        }


        this.ComplexFieldsToQueryIndex = this.complexFieldsToQuery.length;

        //console.log("FieldOptionService:QueryComplexOptionsList() , complexFieldsToQuerySession.length=" + complexFieldsToQuerySession.length);




        this.IsComplexQuery = false;

        //apiService.Post("/api/ComplexOption/QueryOptionsList", complexFieldsToQuerySession).then(
        apiService.Post("/Controllers/ComplexOptionController.aspx/QueryOptionsList",
            {
                Options: complexFieldsToQuerySession
            }
        ).then(
            function (fieldOptionsList) {
                let callBackHandler = null;
                let fieldName = "", dataLanguage = "", options = [];
                let i, j;
                 
                for (i = 0; i < fieldOptionsList.length; i++) {
                    let querys;

                    fieldName = fieldOptionsList[i].FieldName;
                    dataLanguage = fieldOptionsList[i].DataLanguage;
                    options = fieldOptionsList[i].Options;
    

                    dataLanguage = fieldOptionsList[i].DataLanguage;

                    this.complexFieldOptionsSet["Complex@" + fieldName + "@" + dataLanguage] = options;

                    querys = this.complexFieldsToQuery.filter(
                        (query) =>
                            query.FieldName == fieldName &&
                            query.DataLanguage == dataLanguage
                    );


                    for (j = 0; j < querys.length; j++) {

                        if (querys[j].Invoked == true) {
                            continue;
                        }

                        querys[j].Invoked = true;

                        callBackHandler = querys[j].CallBackHandler;

                        if (callBackHandler != null) {
                            callBackHandler(options);
                        }
                    }

                    //callBackHandler = complexFieldsToQuerySession[i].CallBackHandler;

                    //if (callBackHandler != null) {
                    //    callBackHandler(options);
                    //}

                }

                this.IsComplexQuery = false;
                this.IsQuery = false;
            }.bind(this)
        ).catch(
            (error) => {
                alert(error);
            }
        );


    },



    GetOptionText(optionName, optionValue, dataLanguage) {
        let optionText = "";
        let options = null;
        let key;
        let i;

        if (dataLanguage == null) {
            dataLanguage = "ZH_TW";
        }

        key = optionName + "@" + dataLanguage;


        if ((options = this.fieldOptionsSet[key]) != null) {
            for (i = 0; i < options.length; i++) {
                if (options[i].Value == optionValue) {
                    optionText = options[i].Text;
                    break;
                }
            }
        }

        return optionText;
    },

}



export default FieldOptionService;

